// extracted by css-extract-rspack-plugin
export default {"contactSupportLinkWrapper":"_d9b62ffe"};